import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from 'angular-toastify';
import { FinanceManualDetail } from '../../../../../../core/models/finance/finance-manual-list.model';
import { MapperFinanceManualListService } from '../../../../../../core/mappers/finance/mapper-finance-manual-list.service';
import { ApiFinanceManualService } from '../../../../../../core/services/api/finance/api-finance-manual.service';

@Component({
  selector: 'app-modal-revenue-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-revenue-detail.component.html',
  styleUrl: './modal-revenue-detail.component.css',
})
export class ModalRevenueDetailComponent implements OnInit {
  @Input() financeId = 0;
  @Input() siteId = 0;
  @Input() userId = 0;
  @Output() close = new EventEmitter<void>();

  private readonly api = inject(ApiFinanceManualService);
  private readonly mapper = inject(MapperFinanceManualListService);
  private readonly toast = inject(ToastService);

  data: FinanceManualDetail | null = null;
  isLoading = false;
  isVisible = false;
  previewUrl = '';

  ngOnInit(): void {
    setTimeout(() => {
      this.isVisible = true;
    }, 10);

    if (this.financeId > 0) {
      this.loadDetail();
    }
  }

  loadDetail(): void {
    if (!this.financeId || !this.siteId || !this.userId) {
      this.toast.error('ข้อมูลไม่ครบสำหรับโหลดรายละเอียด');
      return;
    }

    this.isLoading = true;
    this.api.getFinanceManualById(this.financeId, this.siteId, this.userId).subscribe({
      next: (res) => {
        this.data = this.mapper.mapDetailFromDto(res);
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
        this.toast.error('ไม่สามารถโหลดรายละเอียดรายได้');
      },
    });
  }

  onClose(): void {
    this.isVisible = false;
    setTimeout(() => this.close.emit(), 200);
  }

  get displayTotal(): number {
    if (!this.data) return 0;
    return this.data.total > 0 ? this.data.total : this.data.fee + this.data.vat;
  }

  openPreview(url: string): void {
    this.previewUrl = url;
  }

  closePreview(): void {
    this.previewUrl = '';
  }
}
